import { render, staticRenderFns } from "./Switch2VBase.vue?vue&type=template&id=58733c80&"
import script from "./Switch2VBase.vue?vue&type=script&lang=ts&"
export * from "./Switch2VBase.vue?vue&type=script&lang=ts&"
import style0 from "./Switch2VBase.vue?vue&type=style&index=0&id=58733c80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports